import * as React from "react";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
const styles = require("./MenuNavigation.module.scss");
import { RouteComponentProps, withRouter } from "react-router-dom";
import Store from "../../store/store";
import { observer } from "mobx-react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import SearchIcon from "@material-ui/icons/Search";
import PersonIcon from "@material-ui/icons/Person";
import DeveloperBoardIcon from "@material-ui/icons/DeveloperBoard";
import SettingsIcon from "@material-ui/icons/Settings";
import DescriptionIcon from "@material-ui/icons/Description";
import AddIcon from "@material-ui/icons/Add";
import FileDocument from "@material-ui/icons/InsertDriveFile";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { Icon } from "@fluentui/react/lib/Icon"
import IconMA from "@material-ui/core/Icon";
import GroupsIcon from "@material-ui/icons/GroupAdd";
import Toggle from "./component/Toggle";
import NavItem from "./component/NavItem";
import { NavItemProps } from "./component/NavItem";

interface INavProps {
  mobile: boolean;
}

interface State {
  expanded: boolean;
  menu: {
    id: string;
    to?: string;
    navIcon?: JSX.Element;
    navText: string;
    title?: string;
    externalLink?: boolean;
    rights?: string[];
    formRight?: string[];
    products?: string[];
    subMenu?: {
      id: string;
      to?: string;
      navText: string;
      externalLink?: boolean;
      title?: string;
      rights?: string[];
      formRight?: string[];
      products?: string[];
    }[];
  }[];
}

@observer
class MenuNavigation extends React.Component<INavProps & RouteComponentProps, State> {
  public constructor(props: INavProps & RouteComponentProps) {
    super(props);
    this.state = {
      expanded: false,
      menu: [
        {
          id: "myaccount",
          to: "/myaccount",
          navIcon: <AccountCircleIcon />,
          navText: Store.userConnected.firstname + " " + Store.userConnected.lastname,
          title: "Mon compte"
        },
        {
          id: "mydashboard",
          to: "/mydashboard",
          navIcon: <DeveloperBoardIcon />,
          navText: "Mon tableau de bord"
        },
        {
          id: "document",
          to: "/document",
          navIcon: <FileDocument />,
          navText: "Mon parapheur"
        },
        {
          id: "search",
          to: "/search",
          navIcon: <SearchIcon />,
          navText: "Effectuer une Recherche"
        },
        {
          id: "users",
          to: "/users",
          navIcon: <PersonIcon />,
          navText: "Utilisateurs",
          rights: ["ged", "admin"]
        },
        {
          id: "groups",
          to: "/groups",
          navIcon: <GroupsIcon />,
          navText: "Gestion des groupes",
          rights: ["ged", "admin"]
        },
        {
          id: "models",
          to: "/models",
          navIcon: <DescriptionIcon />,
          navText: "Modèles",
          rights: ["ged", "admin"]
        },
        {
          id: "roles",
          to: "/roles",
          navIcon: <AddIcon />,
          navText: "Rôles",
          rights: ["ged", "admin"]
        },
        {
          id: "delegation",
          to: "/delegation",
          navIcon: <IconMA>safety_divider</IconMA>,
          navText: "Délégations"
        },
        {
          id: "formulaires",
          navIcon: <Icon iconName="OfficeFormsLogoInverse16" />,
          navText: "Formulaires",
          products: ["form"],
          subMenu: [
            {
              id: "forms",
              to: "/forms",
              navText: "Formulaires"
            },
            {
              id: "createForm",
              to: "/createForm",
              navText: "Création formulaire",
              formRight: ["Admin"]
            },
          ]
        },
        {
          id: "param",
          navIcon: <SettingsIcon />,
          navText: "Paramètres",
          rights: ["ged", "admin"],
          subMenu: [
            {
              id: "parameters",
              to: "/parameters",
              navText: "Paramètres généraux"
            },
            {
              id: "parameterStartAuto",
              to: "/parameterStartAuto",
              navText: "Démarrage auto"
            },
            {
              id: "email",
              to: "/email",
              title: "Paramètres des mails",
              navText: "Mails"
            },
          ]
        },
        {
          id: "sharepoint",
          to: Store.selectedDoc.dataSharepoint != undefined && Store.selectedDoc.dataSharepoint != null && Store.selectedDoc.dataSharepoint.site != undefined && Store.selectedDoc.dataSharepoint.site != undefined && Store.selectedDoc.dataSharepoint.site != null ? Store.selectedDoc.dataSharepoint.site : Store.userConnected.siteUrl,
          navIcon: (<img
            width='100%'
            height="auto"
            src="data:image/png;base64,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"
          />),
          navText: "SharePoint",
          externalLink: true
        }
      ],

    };
  }

  public toggleMenu = (clickAway?: boolean) => {
    if (clickAway) {
      this.setState({ expanded: false });
      Store.menuSharepoint.menuSharepointOpen = false;
    } else {
      this.setState({ expanded: !this.state.expanded });
      Store.menuSharepoint.menuSharepointOpen = !Store.menuSharepoint.menuSharepointOpen;
    }
  };

  public render() {
    const css: React.CSSProperties = this.state.expanded ? {width: "240px"} : {width: "64px"};
    if (this.props.mobile) {
      css.position = "fixed";
      css.top = 0;
      css.left = "-100px";

      if (this.state.expanded) {
        css.width = "100%";
        css.left = 0;
      }
    }
    return (
      <div className={styles.navContainer}>
        {
          this.props.mobile ?
            <div className={styles.mobileToggleContainer}>
              <Toggle onClick={() => this.toggleMenu()} open={this.state.expanded} />
            </div>
            :
            <></>
        }
        <ClickAwayListener onClickAway={this.props.mobile ? () => {} : () => this.toggleMenu(true)}>
          <nav className={styles.navMenu} style={{ ...css }}>
            <Toggle onClick={() => this.toggleMenu()} open={this.state.expanded} />

            <div className={styles.linkContainer}>
              {
                this.state.menu.map((link) => {
                  const linkData: NavItemProps = {
                    ...link,
                    expanded: this.state.expanded,
                    onClick: () => this.toggleMenu(true),
                    active: (link.id == "mydashboard" && this.props.location.pathname == "/") || this.props.location.pathname == link.to || (link.subMenu != undefined && link.subMenu != null && link.subMenu.filter(link => link.to == this.props.location.pathname).length > 0)
                  };

                  let showLink = true;
                  switch (true) {
                    case (link.products != undefined && link.products != null && (Store.paramYes.products == undefined || Store.paramYes.products == null)) || (Store.paramYes.products != undefined && Store.paramYes.products != null && link.products != undefined && link.products != null && link.products.find(product => Store.paramYes.products[product] == true) == undefined):
                      showLink = false;
                      break;

                    case link.rights != undefined && link.rights != null && link.rights.find(right => right == Store.userConnected.typeUserLydoc) == undefined:
                      showLink = false;
                      break;

                    case link.formRight != undefined && link.formRight != null && link.formRight.find(right => right == Store.userConnected.formRights) == undefined:
                      showLink = false;
                      break;

                    default:
                      showLink = true;
                      break;
                  }

                  // linkData.active = link.subMenu != undefined && link.subMenu != null && link.subMenu.filter(link => link.to == this.props.location.pathname).length > 0;

                  if (showLink) {
                    return (
                      <NavItem key={link.id} {...linkData}>
                        {
                          link.subMenu != undefined && link.subMenu != null ?
                            link.subMenu.map(sublink => {
                              const subLinkData: NavItemProps = {
                                ...sublink,
                                expanded: this.state.expanded,
                                onClick: () => this.toggleMenu(true),
                                active: this.props.location.pathname == sublink.to
                              };

                              let showSubLink = true;
                              switch (true) {
                                case (sublink.products != undefined && sublink.products != null && (Store.paramYes.products == undefined || Store.paramYes.products == null)) || (Store.paramYes.products != undefined && Store.paramYes.products != null && sublink.products != undefined && sublink.products != null && sublink.products.find(product => Store.paramYes.products[product] == true) == undefined):
                                  showSubLink = false;
                                  break;
                                case sublink.rights != undefined && sublink.rights != null && sublink.rights.find(right => right == Store.userConnected.typeUserLydoc) == undefined:
                                  showSubLink = false;
                                  break;
                                case sublink.formRight != undefined && sublink.formRight != null && sublink.formRight.find(right => right == Store.userConnected.formRights) == undefined:
                                  showSubLink = false;
                                  break;

                                default:
                                  showSubLink = true;
                                  break;
                              }

                              return (
                                showSubLink ?
                                  <NavItem key={sublink.id} {...subLinkData} />
                                  :
                                  <React.Fragment key={sublink.id} />
                              )
                            })
                            :
                            null
                        }
                      </NavItem>
                    )
                  }
                  else {
                    return (
                      <React.Fragment key={link.id} />
                    )
                  }
                })
              }
            </div>
            <div className={styles.versionApp}>
              {"V " + process.env.VERSION}
            </div>
          </nav>
        </ClickAwayListener>
      </div>
    );
  }
}
export default withRouter(MenuNavigation);
